import React from "react";
import solanaIcon from "../../../assets/solanaIcon.svg";
import styles from "./Details.module.scss";

const Details = () => {
  return (
    <div className={styles.container}>
      <h5>Properties</h5>
      <div className={styles.cards}>
        <div className={styles.card}>
          <h6>Background</h6>
          <small>Purple</small>
        </div>
        <div className={styles.card}>
          <h6>Overlay</h6>
          <small>Yes</small>
        </div>
        <div className={styles.card}>
          <h6>Type</h6>
          <small>Photo</small>
        </div>
        <div className={styles.card}>
          <h6>Leaves</h6>
          <small>Yes</small>
        </div>
        <div className={styles.card}>
          <h6>Teeth</h6>
          <small>Yes</small>
        </div>
      </div>

      <h5>Blockchain</h5>
      <div className={styles.chain}>
        <div className={styles.img}>
          <img src={solanaIcon} alt="solana" />
        </div>
        <h6>Solana</h6>
      </div>
    </div>
  );
};

export default Details;
